module.exports = __webpack_public_path__ + "h5/img/bs_23.8ff5fdb0.jpg";